import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdCheckbox } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheckCircle, MdHome, MdLightMode, MdLocationPin, MdSearch } from "react-icons/md";

import OneObjective from "./OneObjective";

import banner1 from '../assets/banner2.jpg';
import banner2 from '../assets/banner2.jpg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import banner6 from '../assets/banner6.jpg';
import banner7 from '../assets/banner7.jpg';
import overlay from '../assets/overlay.jpg';
import logo from '../assets/logo.png';

export default function AboutUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);
	const [ bgIndex, setBgIndex ] = useState(0);
	const banners = [banner5, banner7, banner1, banner2, banner3, banner4, ];

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	useEffect(() => {
		if (!ready) return;

		const interval = setInterval(() => {
			setBgIndex(prev => (prev + 1) % banners.length);
		}, 2500); // change every 5 seconds

		return () => clearInterval(interval);
	}, [ready]);

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
				}}
			>

					<div
						style={{
							backgroundImage: `url(${banner1})`,
							backgroundSize: 'cover',
							backgroundPosition: 'center',
							backgroundRepeat: 'no-repeat',
							height: "calc(100vh - var(--topBarHeight))",
							position: "relative"
						}}
					>
						<div style={{width:"100%", height:"100%", background:"rgba(0,0,0,.7)"}}>
							<div
								className="text-center"
								style={{
									position: "absolute",
									top: "40%",
									left: "50%",
									transform: "translate(-50%)"
								}}
							>
								<h1 className="text-light text-center font-semi-bold">About ZAMANI SABIOS GROUP <br/> ZSG</h1>
								<h4 className="text-primary text-center font-semi-bold mt-5">
									Over 250+ Years of Combined Experience
								</h4>
							</div>
						</div>
						
					</div>

					

				<div 
					className="MainBodySection" 
					style={{
						backgroundImage: `url(${overlay})`,
						backgroundSize: 'cover',
						backgroundPosition: 'center',
						backgroundRepeat: 'no-repeat',
						overflow:"hidden"
					}}
				>
					<div 
						className="row pt-3 pb-5"
						
					>
						<div className="col-md-12 mt-5 px-5 text-center">
							<img src={logo} height={150}/>
						</div>

						<div className="col-md-12 p-5 mt-3">
							<div className="bg-light rounded p-5 mShadow2">
								<h1 className="text-primary font-bold mb-3">
									Zamani Sabios Group - ZSG
								</h1>
								<h5>
									Zamani Sabios Group is a team of senior professionals with more than 250 years of combined experience across management and technical fields. Established in 2025 in line with Section 64 of the Public Procurement Act 2023 and Regulations 33 to 36 of the Public Procurement Regulations 2024, the group supports Tanzania’s economic and social development goals.
									<br/><br/>
									We provide practical solutions to organisational, management, and development challenges across Tanzania, East Africa, and the wider continent. The group is registered in Tanzania under the President’s Office - Regional Administration and Local Government Authorities, Kinondoni Municipal (certificate No. KMC/YGR/4114) and holds a BRELA Business name registration certificate numbered 612569.
									<br/><br/>
									ZSG works with public, private, and nonprofit institutions, focusing on sustainable, evidence-based solutions. Our members have extensive experience in management, procurement, supply chain, logistics, feasibility studies, impact evaluations, project and programme reviews, institutional capacity development, monitoring and evaluation, legal work, organisational change, policy analysis, financial management, mapping studies, and development cooperation.
									<br/><br/>
									The group partners with institutions and professionals across sectors to meet client requirements. By combining long-standing professional experience with analytical precision and practical knowledge, ZSG ensures that organisations receive tailored solutions that align with sector needs.
								</h5>
							</div>
						</div>
						
						<div className="col-md-9 m-auto mt-3 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR VISION
							</h6>

							<h5
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								To be a trusted partner for organisations seeking practical solutions and long-term institutional growth.
								<br/>
								The group seeks to contribute to national and regional development through competence, integrity, and consistent delivery.
		
							</h5>
							
						</div>

						<div className="col-md-9 m-auto mt-5 px-5">
														
							<h6
								style={{
									fontSize: "32px",
									textTransform: "uppercase"
								}}
								className="text-center text-secondary font-bold mt-3 mb-2"
							>
								OUR MISSION
							</h6>

							<h5
								style={{
									fontSize: "16px",
								}}
								className="font-semi-bold text-center px-5"
							>
								To provide practical and evidence-based solutions that strengthen management, organisational performance, and development outcomes across Tanzania, East Africa, and the wider continent.
								<br/>
								The group aims to support public, private, and non-profit institutions through applied knowledge, experience, and collaboration.

							</h5>
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}